import Reflux from 'reflux';
export default Reflux.createActions([
  'open',
  'close'
]);




// WEBPACK FOOTER //
// ./src/app/zoom-images/zoom-layer/actions.js